"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.heightPropDefs = void 0;
const heightValues = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
const heightPropDefs = {
    height: {
        type: 'enum | string',
        className: 'rt-r-h',
        customProperties: ['--height'],
        values: heightValues,
        default: undefined,
        responsive: true,
    },
    minHeight: {
        type: 'enum | string',
        className: 'rt-r-min-h',
        customProperties: ['--min-height'],
        values: heightValues,
        default: undefined,
        responsive: true,
    },
    maxHeight: {
        type: 'enum | string',
        className: 'rt-r-max-h',
        customProperties: ['--max-height'],
        values: heightValues,
        default: undefined,
        responsive: true,
    },
};
exports.heightPropDefs = heightPropDefs;
//# sourceMappingURL=height.props.js.map